import { useLazyQuery, useQuery } from "@apollo/client";
import { MAIL_MESSAGES } from "../mail-message.queries";
import {
  MailMessagesQuery,
  MailMessagesQueryVariables,
} from "../../../__generated__/MailMessagesQuery";

export const useMailMessages = (variables: MailMessagesQueryVariables) => {
  return useQuery<MailMessagesQuery, MailMessagesQueryVariables>(MAIL_MESSAGES, {
    variables,
  });
};

export const useLazyMailMessages = () => {
  return useLazyQuery<MailMessagesQuery, MailMessagesQueryVariables>(MAIL_MESSAGES);
};
